import { constants, ContextMenuMain, ContextMenuNavigationItem, ContextMenuSeparator, ContextMenuSettingsItem, IconClock, IconProfile, IconSpeechBubble } from '@klarna/bubble-ui';
import { format } from 'date-fns-tz';
import { hooks as coreHooks } from 'mage-core';
import { hooks as i18nHooks } from 'mage-i18n';
import PropTypes from 'prop-types';
import React from 'react';
const GRID_SIZE = constants.Grid.SIZE;
const styleSheet = {
    menu: {
        position: 'relative',
        display: 'block',
        top: 2 * GRID_SIZE,
        width: 300
    }
};
const Menu = ({ onLanguageClick, onLogoutClick, onProfileClick }) => {
    const tokenHelper = coreHooks.useTokenHelper();
    const isInMerchantsRealm = tokenHelper.isInMerchantsRealm();
    const t = i18nHooks.useTranslator();
    const language = i18nHooks.useLanguage();
    return (React.createElement("div", { id: 'usermenu-menu', style: styleSheet.menu },
        React.createElement(ContextMenuMain, null,
            React.createElement(ContextMenuSettingsItem, { id: 'usermenu-menu-language', onClick: onLanguageClick, icon: IconSpeechBubble, label: t('core.usermenu.language'), value: t(`core.languages.${language}`) }),
            React.createElement(ContextMenuSettingsItem, { id: 'usermenu-menu-tz', icon: IconClock, label: t('core.usermenu.timezone'), value: format(new Date(), 'z', { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }) }),
            isInMerchantsRealm && (React.createElement(ContextMenuSettingsItem, { id: 'usermenu-menu-profile', onClick: onProfileClick, icon: IconProfile, label: t('core.usermenu.profile'), value: t('core.usermenu.changeProfile') })),
            React.createElement(ContextMenuSeparator, { key: 'separator' }),
            React.createElement(ContextMenuNavigationItem, { id: 'usermenu-menu-logout', onClick: onLogoutClick, label: t('core.usermenu.logout') }))));
};
Menu.propTypes = {
    onLanguageClick: PropTypes.func.isRequired,
    onLogoutClick: PropTypes.func.isRequired,
    onProfileClick: PropTypes.func.isRequired
};
export default Menu;
